export function squashToStart(date: string | Date): string {
  let temp: Date;
  temp = typeof date === 'string' ? new Date(coerceZULU(date)) : date;
  return new Date(temp.setHours(0, 0, 0)).toISOString();
}

export function squashToEnd(date: string | Date): string {
  let temp: Date;
  temp = typeof date === 'string' ? new Date(coerceZULU(date)) : date;
  return new Date(temp.setHours(23, 59, 59)).toISOString();
}

export function squashToStartD(date: string | Date): Date {
  let temp: Date;
  temp = typeof date === 'string' ? new Date(coerceZULU(date)) : date;
  return new Date(temp.setHours(0, 0, 0));
}

export function squashToEndD(date: string | Date): Date {
  let temp: Date;
  temp = typeof date === 'string' ? new Date(coerceZULU(date)) : date;
  return new Date(temp.setHours(23, 59, 59));
}

export function coerceZULU(val: string): string {
  return val.endsWith('Z') ? val : `${val}Z`;
}
